// Central brand + content configuration for KAS Info Tech
export const BRAND = {
  name: "KAS Info Tech (P) Ltd.",
  short: "KAS",
  tagline: "Your Trusted IT Security & Surveillance Partner",
  heroLine: "Securing India's Digital & Physical Infrastructure",
  email: "kasinfotec@gmail.com",
  phone: "+91 80581 22233",
  phoneRaw: "918058122233",
  whatsapp: "918058122233",
  supportLine: "+91 80581 22233",
  address: "Alwar, Rajasthan, India",
  established: 2014,
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Industries", to: "/industries" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const STATS = [
  { value: 900, suffix: "+", label: "Successful Deployments" },
  { value: 500, suffix: "+", label: "Business Clients Served" },
  { value: 24, suffix: "/7", label: "Managed Tech Support" },
  { value: 10, suffix: "+ yrs", label: "Industry Expertise" },
];

export const TRUST_BADGES = ["ISO Certified", "Government Empanelled", "900+ Installations", "Pan-India Presence"];

export const SERVICES = [
  {
    slug: "cctv-surveillance",
    title: "Smart Surveillance & Security",
    icon: "Cctv",
    short: "IP & AI-powered thermal camera systems, automated NVR/DVR setups, and central monitoring.",
    description:
      "End-to-end video surveillance — from a single storefront to statewide networks. We design, install and maintain camera systems with remote monitoring, motion detection, night vision and AI-powered analytics.",
    features: [
      "IP, HD analog, PTZ, thermal, dome & bullet cameras",
      "NVR / DVR storage & centralised recording",
      "Remote monitoring, motion detection & night vision",
      "AI analytics — intrusion, ANPR, people counting",
    ],
    solutions: ["Retail", "Industrial", "Government", "Residential"],
    partners: ["Hikvision", "Dahua", "Axis", "Honeywell"],
    image: "hero_cctv",
  },
  {
    slug: "enterprise-networking",
    title: "Network Infrastructure & Security",
    icon: "Network",
    short: "End-to-end structured cabling, enterprise firewalls, managed switches, and high-speed Wi-Fi.",
    description:
      "Reliable, secure networks built for scale. We handle everything from Cat6/fiber structured cabling to firewall deployment, enterprise Wi-Fi and LAN/WAN optimisation.",
    features: [
      "Structured cabling — Cat6 & fiber optics",
      "Network design & implementation",
      "Firewall & perimeter security",
      "Enterprise Wi-Fi & LAN/WAN optimisation",
    ],
    solutions: ["Corporate", "Government", "Education", "Manufacturing"],
    partners: ["Cisco", "Ubiquiti", "Fortinet", "TP-Link"],
    image: "networking",
  },
  {
    slug: "access-control-biometric",
    title: "Biometric & Identity Management",
    icon: "Fingerprint",
    short: "Advanced facial recognition, RFID, and mobile-first access control systems for enterprises.",
    description:
      "Control who goes where. Our access systems combine fingerprint, facial recognition and RFID with attendance integration and mobile-based unlocking for modern facilities.",
    features: [
      "Fingerprint & facial recognition scanners",
      "RFID card & mobile-based access",
      "Multi-door & multi-site management",
      "Integration with attendance & payroll",
    ],
    solutions: ["Corporate", "Healthcare", "Education", "Government"],
    partners: ["ZKTeco", "eSSL", "Suprema", "Matrix"],
    image: "biometric",
  },
  {
    slug: "epabx-systems",
    title: "VoIP & Business Communications",
    icon: "PhoneCall",
    short: "Digital PBX, IP telephony, unified communications, and integrated call center infrastructure.",
    description:
      "Modern business telephony — digital EPABX, VoIP and call-centre solutions with auto-attendant, IVR and seamless scaling as your team grows.",
    features: [
      "Digital EPABX & IP phone systems",
      "VoIP & SIP trunking",
      "Call centre & IVR solutions",
      "Auto-attendant & call analytics",
    ],
    solutions: ["Corporate", "Hospitality", "Healthcare", "Retail"],
    partners: ["Matrix", "Panasonic", "Grandstream", "Yeastar"],
    image: "server_room",
  },
  {
    slug: "smart-classes-board-room",
    title: "Smart Classes & Board Room Setup",
    icon: "Presentation",
    short: "Interactive displays, video conferencing and smart classroom setups.",
    description:
      "Transform your meeting spaces and classrooms into interactive digital environments with state-of-the-art interactive flat panels, video conferencing systems, and seamless audio-visual integration.",
    features: [
      "Interactive flat panels & smart boards",
      "Video conferencing & collaboration tools",
      "Audio-visual integration & acoustics",
      "Complete boardroom automation",
    ],
    solutions: ["Education", "Corporate", "Government", "Training"],
    partners: ["Logitech", "Poly", "Maxhub", "Samsung"],
    image: "tech_support",
  },
  {
    slug: "web-app-development",
    title: "Custom Software & App Engineering",
    icon: "Code2",
    short: "High-performance websites, native mobile applications, and digital transformation workflows.",
    description:
      "Custom digital products — web applications, e-commerce platforms and native mobile apps — built to modernise operations and delight your users.",
    features: [
      "Custom web applications & portals",
      "E-commerce platforms",
      "Android & iOS mobile apps",
      "End-to-end digital transformation",
    ],
    solutions: ["Corporate", "Education", "Healthcare", "Retail"],
    partners: [],
    image: "networking",
  },
  {
    slug: "computer-lab-setup",
    title: "Institutional IT & Lab Infrastructure",
    icon: "Computer",
    short: "Turnkey computer lab setups, workstation provisioning, and IT hardware management for orgs.",
    description:
      "Turnkey computer labs for schools, colleges and training centres — workstation deployment, networking, software licensing and ongoing maintenance.",
    features: [
      "Complete lab infrastructure & workstations",
      "Network connectivity & cabling",
      "Software licensing & imaging",
      "Annual maintenance contracts (AMC)",
    ],
    solutions: ["Education", "Government", "Corporate", "Training"],
    partners: [],
    image: "server_room",
  },
  {
    slug: "attendance-systems",
    title: "Attendance & Payroll Integration",
    icon: "UserCheck",
    short: "Automated cloud attendance tracking with seamless integration into modern HR/payroll tools.",
    description:
      "Accurate, tamper-proof attendance using biometric and RFID technology, with cloud-based tracking and direct integration into your payroll.",
    features: [
      "Biometric & RFID attendance",
      "Cloud-based tracking & reports",
      "Multi-location & shift management",
      "Payroll integration",
    ],
    solutions: ["Corporate", "Education", "Government", "Manufacturing"],
    partners: ["ZKTeco", "eSSL", "Matrix"],
    image: "biometric",
  },
];

export const PROJECTS = [
  { slug: "rajasthan-police", title: "Rajasthan Police Statewide Surveillance", category: "Government", metric: "850+ Stations", scope: "Statewide IP surveillance network across 850+ police stations.", duration: "Multi-phase", image: "hero_cctv", client: "Rajasthan Police" },
  { slug: "alwar-railway", title: "Alwar Railway Station Surveillance", category: "Government", metric: "60+ Cameras", scope: "50+ IP cameras & 10+ PTZ cameras covering platforms and concourse.", duration: "8 weeks", image: "server_room", client: "Indian Railways" },
  { slug: "metso-india", title: "Metso India Corporate Security", category: "Corporate", metric: "Full Site", scope: "Corporate security infrastructure — surveillance & access control.", duration: "6 weeks", image: "networking", client: "Metso India" },
  { slug: "pepsi-india", title: "Pepsi India Enterprise Surveillance", category: "Corporate", metric: "Enterprise", scope: "Enterprise-grade surveillance across manufacturing facilities.", duration: "10 weeks", image: "biometric", client: "Pepsi India" },
  { slug: "dmart", title: "Dmart Multi-Store Surveillance", category: "Retail", metric: "200+ Cameras", scope: "200+ cameras deployed across multiple retail locations.", duration: "Ongoing", image: "hero_cctv", client: "Dmart" },
  { slug: "blinkit", title: "Blinkit Dark-Store Security", category: "Retail", metric: "100+ Cameras", scope: "100+ cameras securing dark stores for quick commerce.", duration: "Ongoing", image: "server_room", client: "Blinkit" },
  { slug: "modulus-academy", title: "Modulus Academy Digital Transformation", category: "Education", metric: "Complete", scope: "Complete digital transformation — labs, network & software.", duration: "12 weeks", image: "networking", client: "Modulus Academy" },
  { slug: "arakis-energy", title: "Arakis Energy Solar Plant Security", category: "Industrial", metric: "Solar Farm", scope: "Perimeter surveillance & security for solar power plant.", duration: "6 weeks", image: "tech_support", client: "Arakis Energy" },
  { slug: "arya-health-care", title: "Arya Health Care HMS + App", category: "Healthcare", metric: "HMS + App", scope: "Hospital Management System with patient mobile application.", duration: "16 weeks", image: "biometric", client: "Arya Health Care" },
];

export const PROJECT_CATEGORIES = ["All", "Government", "Corporate", "Healthcare", "Education", "Retail", "Industrial"];

export const CLIENTS = [
  { name: "Rajasthan Police", short: "RP", type: "Government" },
  { name: "Indian Railways", short: "IR", type: "Government" },
  { name: "Metso", short: "MO", type: "Corporate" },
  { name: "Pepsi", short: "PE", type: "Corporate" },
  { name: "Dmart", short: "DM", type: "Retail" },
  { name: "Blinkit", short: "BK", type: "Retail" },
  { name: "Arakis Energy", short: "AE", type: "Industrial" },
  { name: "Arya Health Care", short: "AH", type: "Healthcare" },
];

// Detailed case-study content keyed by project slug
export const PROJECT_DETAILS = {
  "rajasthan-police": {
    overview: "A statewide surveillance modernisation covering 850+ police stations, delivering centralised monitoring, tamper-proof recording and rapid incident response for one of India's largest police forces.",
    challenge: "Deploy a uniform, reliable surveillance network across hundreds of geographically dispersed stations — many in remote areas — with centralised oversight, minimal downtime and strict chain-of-custody for footage.",
    solution: [
      "Standardised IP camera + NVR architecture across all 850+ stations",
      "Centralised command-centre monitoring with role-based access",
      "Redundant local + central recording to guarantee footage integrity",
      "Phased rollout with trained local support teams in each region",
    ],
    results: [
      { value: "850+", label: "Stations secured" },
      { value: "100%", label: "Central visibility" },
      { value: "24/7", label: "Monitoring & support" },
    ],
    services: ["Smart Surveillance & Security", "Network Infrastructure & Security"],
    gallery: ["hero_cctv", "server_room", "networking"],
    testimonial: { quote: "The coordination across hundreds of sites was exceptional — reliable footage, centralised control and dependable support.", author: "Senior Official, State Police Department" },
  },
  "alwar-railway": {
    overview: "A comprehensive surveillance deployment at Alwar Railway Station covering platforms, concourse and entry points with a blend of fixed IP and PTZ cameras.",
    challenge: "Cover a high-footfall public transit hub with zero blind spots, while operating around live train schedules and heavy passenger movement.",
    solution: [
      "50+ fixed IP cameras for wide-area platform coverage",
      "10+ PTZ cameras for active tracking of points of interest",
      "Night-vision and weather-resistant enclosures for outdoor zones",
      "Installation scheduled around live operations for zero disruption",
    ],
    results: [
      { value: "60+", label: "Cameras deployed" },
      { value: "0", label: "Operational disruption" },
      { value: "8 wks", label: "End-to-end delivery" },
    ],
    services: ["Smart Surveillance & Security"],
    gallery: ["server_room", "hero_cctv", "tech_support"],
    testimonial: null,
  },
  "metso-india": {
    overview: "Corporate security infrastructure for Metso India combining surveillance and access control across office and facility zones.",
    challenge: "Protect corporate premises and restricted areas while integrating with existing IT infrastructure and access policies.",
    solution: [
      "Integrated surveillance + access-control design",
      "Perimeter and interior camera coverage",
      "Role-based access with attendance integration",
      "Centralised dashboards for the facilities team",
    ],
    results: [
      { value: "Full", label: "Site coverage" },
      { value: "6 wks", label: "Delivery time" },
      { value: "1", label: "Unified platform" },
    ],
    services: ["Smart Surveillance & Security", "Biometric & Identity Management"],
    gallery: ["networking", "biometric", "server_room"],
    testimonial: { quote: "Reliable, professional and available around the clock. Our facilities have never been more secure.", author: "Facilities Head" },
  },
  "pepsi-india": {
    overview: "Enterprise-grade surveillance across Pepsi India manufacturing facilities to safeguard production, inventory and personnel.",
    challenge: "Deliver consistent, high-availability surveillance across large industrial facilities with harsh environmental conditions.",
    solution: [
      "Industrial-grade cameras rated for demanding environments",
      "High-availability recording with redundancy",
      "Coverage of production lines, storage and perimeters",
      "Remote monitoring for multi-site oversight",
    ],
    results: [
      { value: "Enterprise", label: "Scale" },
      { value: "10 wks", label: "Delivery time" },
      { value: "99.9%", label: "Uptime" },
    ],
    services: ["Smart Surveillance & Security", "Network Infrastructure & Security"],
    gallery: ["server_room", "networking", "hero_cctv"],
    testimonial: null,
  },
  "dmart": {
    overview: "A large-scale retail surveillance programme deploying 200+ cameras across multiple Dmart locations for loss prevention and operational oversight.",
    challenge: "Standardise surveillance across many stores with centralised monitoring and consistent quality, deployed without disrupting retail operations.",
    solution: [
      "200+ cameras across multiple store formats",
      "Centralised multi-store monitoring",
      "Coverage of aisles, billing, entry/exit and stockrooms",
      "Ongoing maintenance and rapid support",
    ],
    results: [
      { value: "200+", label: "Cameras deployed" },
      { value: "Multi", label: "Store rollout" },
      { value: "24/7", label: "Support" },
    ],
    services: ["Smart Surveillance & Security"],
    gallery: ["hero_cctv", "tech_support", "server_room"],
    testimonial: { quote: "200+ cameras across our stores, deployed on schedule with zero disruption to operations.", author: "Operations Manager, Retail Chain" },
  },
  "blinkit": {
    overview: "Security coverage for Blinkit dark stores enabling quick-commerce operations to run safely and efficiently, with 100+ cameras deployed.",
    challenge: "Rapidly secure a growing network of dark stores with reliable, easy-to-monitor surveillance suited to fast-paced fulfilment.",
    solution: [
      "100+ cameras across dark-store network",
      "Coverage of picking, packing and dispatch zones",
      "Remote monitoring for operations teams",
      "Scalable rollout as new stores open",
    ],
    results: [
      { value: "100+", label: "Cameras deployed" },
      { value: "Scalable", label: "Rollout model" },
      { value: "Fast", label: "Turnaround" },
    ],
    services: ["Smart Surveillance & Security"],
    gallery: ["tech_support", "server_room", "networking"],
    testimonial: null,
  },
  "modulus-academy": {
    overview: "A complete digital transformation for Modulus Academy — computer labs, campus networking and software — delivered as a single turnkey programme.",
    challenge: "Modernise an education campus end to end: reliable network, fully-equipped labs and licensed software, ready for students on schedule.",
    solution: [
      "Complete computer-lab setup with workstations",
      "Structured cabling and campus-wide connectivity",
      "Software licensing and imaging",
      "Ongoing maintenance contract",
    ],
    results: [
      { value: "Turnkey", label: "Delivery" },
      { value: "12 wks", label: "Timeline" },
      { value: "AMC", label: "Ongoing support" },
    ],
    services: ["Institutional IT & Lab Infrastructure", "Network Infrastructure & Security"],
    gallery: ["networking", "server_room", "tech_support"],
    testimonial: null,
  },
  "arakis-energy": {
    overview: "Perimeter surveillance and security for an Arakis Energy solar power plant, protecting valuable infrastructure across a large outdoor footprint.",
    challenge: "Secure a sprawling outdoor solar farm against intrusion and theft, with weather-resistant equipment and reliable remote monitoring.",
    solution: [
      "Weatherproof perimeter camera coverage",
      "Long-range and PTZ cameras for wide areas",
      "Remote monitoring with intrusion alerts",
      "Ruggedised recording and power resilience",
    ],
    results: [
      { value: "Full", label: "Perimeter secured" },
      { value: "6 wks", label: "Delivery time" },
      { value: "24/7", label: "Monitoring" },
    ],
    services: ["Smart Surveillance & Security"],
    gallery: ["tech_support", "hero_cctv", "networking"],
    testimonial: null,
  },
  "arya-health-care": {
    overview: "A full Hospital Management System with a patient mobile application for Arya Health Care, streamlining patient care, billing and operations.",
    challenge: "Digitise hospital operations end to end — records, scheduling, billing and inventory — with a patient-facing app and integration into existing systems.",
    solution: [
      "Comprehensive HMS: records, scheduling, billing, inventory",
      "Patient mobile app for Android & iOS",
      "Integration with hospital infrastructure",
      "Training and ongoing support",
    ],
    results: [
      { value: "HMS", label: "+ patient app" },
      { value: "16 wks", label: "Delivery time" },
      { value: "End-to-end", label: "Digitisation" },
    ],
    services: ["Smart Classes & Board Room Setup", "Custom Software & App Engineering"],
    gallery: ["biometric", "tech_support", "networking"],
    testimonial: { quote: "From cameras to a complete HMS with a patient app — they handled our entire digital transformation end to end.", author: "Administrator, Arya Health Care" },
  },
};

export const INDUSTRIES = [
  { title: "Government", icon: "Landmark", body: "Police, railways & public infrastructure — trusted for mission-critical, large-scale deployments.", image: "hero_cctv" },
  { title: "Corporate", icon: "Building2", body: "Manufacturing, FMCG and IT companies — securing offices, plants and data.", image: "networking" },
  { title: "Retail", icon: "ShoppingCart", body: "Malls, supermarkets & warehouses — loss prevention and multi-store monitoring.", image: "server_room" },
  { title: "Healthcare", icon: "HeartPulse", body: "Hospitals, clinics & pharma — surveillance, access control and HMS.", image: "biometric" },
  { title: "Education", icon: "GraduationCap", body: "Schools, colleges & universities — safe campuses and complete IT labs.", image: "tech_support" },
  { title: "Hospitality", icon: "Hotel", body: "Hotels, resorts & restaurants — guest safety and integrated telephony.", image: "networking" },
  { title: "Industrial", icon: "Factory", body: "Factories, plants & solar farms — perimeter security and 24/7 monitoring.", image: "server_room" },
];

export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Government-Grade Trust", body: "Chosen for statewide, mission-critical deployments including 850+ police stations." },
  { icon: "Clock", title: "24/7 Technical Support", body: "Round-the-clock support and rapid on-site response across India." },
  { icon: "Award", title: "Proven Track Record", body: "900+ successful installations for government and corporate leaders." },
  { icon: "MapPin", title: "Pan-India Presence", body: "On-ground teams and partners delivering nationwide, on time." },
];

export const TESTIMONIALS = [
  { quote: "KAS Info Tech delivered a statewide surveillance rollout flawlessly. Their coordination across hundreds of sites was exceptional.", name: "Senior Official", role: "State Police Department" },
  { quote: "Reliable, professional and available around the clock. Our manufacturing facilities have never been more secure.", name: "Facilities Head", role: "Leading FMCG Company" },
  { quote: "From cameras to complete HMS with a patient app — they handled our entire digital transformation end to end.", name: "Administrator", role: "Arya Health Care" },
  { quote: "200+ cameras across our stores, deployed on schedule with zero disruption to operations. Highly recommended.", name: "Operations Manager", role: "Retail Chain" },
];

export const BLOG_POSTS = [
  { title: "Choosing between IP and analog CCTV in 2026", category: "Surveillance", date: "Jul 2026", read: "5 min", image: "hero_cctv", excerpt: "IP cameras dominate new installs — but analog still has a place. Here's how to decide for your site." },
  { title: "AI video analytics: beyond motion detection", category: "AI & Security", date: "Jun 2026", read: "6 min", image: "server_room", excerpt: "ANPR, intrusion detection and people counting are changing what surveillance can do for operations." },
  { title: "Structured cabling done right", category: "Networking", date: "Jun 2026", read: "4 min", image: "networking", excerpt: "Cat6 vs fiber, cable management and the standards that keep enterprise networks fast and reliable." },
  { title: "Biometric vs RFID access control", category: "Access Control", date: "May 2026", read: "5 min", image: "biometric", excerpt: "Which access technology fits your facility? A practical comparison for security decision-makers." },
];

export const FAQS = [
  { q: "Do you provide a free site survey?", a: "Yes. Our engineers visit your premises, assess requirements and provide a tailored proposal at no cost. Request one from the Contact page or via WhatsApp." },
  { q: "Which areas in India do you serve?", a: "We operate pan-India with on-ground teams and partners, and have delivered projects across government, corporate, retail and healthcare sectors nationwide." },
  { q: "Do you offer annual maintenance contracts (AMC)?", a: "Yes. We provide AMC options with 24/7 support, preventive maintenance and rapid on-site response to keep your systems running." },
  { q: "Which camera and hardware brands do you work with?", a: "We are technology-agnostic and partner with leading brands including Hikvision, Dahua, Axis, Honeywell, ZKTeco, eSSL, Matrix, Cisco and more." },
  { q: "Can you integrate surveillance with access control and attendance?", a: "Absolutely. We design integrated systems where surveillance, access control, biometric attendance and payroll work together seamlessly." },
  { q: "How do I get support after installation?", a: "Our 24/7 helpline and dedicated support team handle any issues. AMC clients receive priority response and scheduled maintenance." },
];

export const OFFICES = [
  { city: "Alwar (HQ)", address: "Alwar, Rajasthan, India", phone: "+91 80581 22233" },
  { city: "Jaipur", address: "Jaipur, Rajasthan, India", phone: "+91 80581 22233" },
  { city: "Delhi", address: "New Delhi, India", phone: "+91 80581 22233" },
  { city: "Bhiwadi", address: "Bhiwadi, Rajasthan, India", phone: "+91 80581 22233" },
];

export const CERTIFICATIONS = ["ISO 9001:2015", "Government Empanelled", "OEM Certified Partner", "Skilled & Trained Engineers"];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title).concat(["Site Survey", "AMC / Support", "Other"]);

export const IMAGES = {
  hero_cctv: "https://images.pexels.com/photos/96612/pexels-photo-96612.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  networking: "https://images.unsplash.com/photo-1629837093109-11325d6e7afd?crop=entropy&cs=srgb&fm=jpg&q=85",
  server_room: "https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&q=85",
  biometric: "https://images.unsplash.com/photo-1776329255945-15212b50cd7f?crop=entropy&cs=srgb&fm=jpg&q=85",
  tech_support: "https://images.unsplash.com/photo-1632910121591-29e2484c0259?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const img = (key) => IMAGES[key] || IMAGES.hero_cctv;
